module.exports = __webpack_public_path__ + "media/images/athletes/2019-e408036a6164004cb6c4cf691a4e31b1.png";